import { LatLong } from '../../types/geo';

const EARTH_RADIUS = 6371.0088;
const TO_RAD = Math.PI / 180;
export const toRadians = (value: number) => value * TO_RAD;

/**
 * calculates the distance of two geolocations in meters.
 * @param {LatLong} from
 * @param {LatLong} to
 */
export const distance = (from: LatLong, to: LatLong) => {
  // haversine formula, adapted implementation of daniel braun
  // http://www.daniel-braun.com/technik/distanz-zwischen-zwei-gps-koordinaten-in-java-berchenen/
  const lat = toRadians(to.lat - from.lat);
  const lng = toRadians(to.lng - from.lng);
  const latFromRad = toRadians(from.lat);
  const latToRad = toRadians(to.lat);
  const sinLat = Math.sin(lat / 2);
  const sinLng = Math.sin(lng / 2);
  const a = sinLat * sinLat + Math.cos(latFromRad) * Math.cos(latToRad) * sinLng * sinLng;
  return Math.abs(EARTH_RADIUS * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)))) * 1000;
};
